import { useEffect, useState } from 'react';

export const useDebounce = (value: string, milliSeconds: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    if( globalThis.window !== undefined) {
        const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, milliSeconds);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [value, milliSeconds]);

  return debouncedValue;
};